/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Staff_NameInputs */

const vi_report_staff_name = /** @type {(inputs: Report_Staff_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhân viên`)
};

/**

* @param {Report_Staff_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_staff_name = /** @type {((inputs?: Report_Staff_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Staff_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_staff_name(inputs)
});